import React from 'react';
import classNames from 'classnames';
import EventSearchArticleListBlock from '../components/event-search-article-list-block';
import * as Render from '../platformui/Base/Render';
import SearchArticleListBlock from '../platformui/SearchArticleList';

const Blocks = {
  SearchArticleListBlock,
  EventSearchArticleListBlock,
};

const DoubleColumnBlock = (props) => {
  const sectionHeader = classNames({
    'c-section__header': true,
    'c-section__header--heading-shown': props.Heading,
    'c-section__header--hidden': !props.Heading,
    'c-section__heading--center': props.Heading,
  });

  return (
    <section className="c-section c-section__double-column">
      <header className={sectionHeader}>
        {props.Heading && (
          <h2 className="c-section__heading">
            <span>{props.Heading}</span>
          </h2>
        )}
      </header>
      <Render.Block
        blocks={props.DoubleColumnContent}
        propertyName="MainContent"
        currentPageProps={props}
        stylePropertyName="SectionContent"
        Modifiers={{ 'c-section': true, 'c-section__heading--center': true }}
      >
        <Render.BlockTypeRenderer Blocks={Blocks} />
      </Render.Block>
    </section>
  );
};

export default DoubleColumnBlock;
